xÿ
<template>
    <div data-component="M_AMS_Resultlist_Hydrated">
        <ams-resultlist
            :hasPriceIndicator="hasPriceIndicator"
            :hasStickyFilter="hasStickyFilter"
            :hasStickyFilterTags="hasStickyFilterTags"
            @price-indicator-click="onPriceIndicatorClick"
            @item-click="onItemClick"
            @item-in-viewport="onItemInViewport"
        >
            <template v-for="disturber in disturbers" :key="disturber.cmsId" #[slotNameForDisturber(disturber)]>
                <ms-disturber :cms-content="disturber" class="ams-resultListDisturber" />
            </template>
        </ams-resultlist>
    </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { Cms } from '@sunrise/types'
import AmsResultlist from '../../../components/AmsResultlist'
import { M_Resultlist_Disturber_Container as MsDisturber } from '@sunrise/components'
import { useTracking } from './useTracking'
import { AmsItem } from '../../../services/amsSearch/amsSearch.interface'
import { slotNameForDisturber } from '../../../utils/cmsUtils'

defineProps({
    disturbers: {
        type: Array as PropType<Cms.Content[]>,
        required: true,
    },
    hasPriceIndicator: Boolean,
    hasStickyFilter: {
        type: Boolean,
        required: true,
    },
    hasStickyFilterTags: Boolean,
})

const { track } = useTracking('M_AMS_Resultlist')

const onItemClick = (event: MouseEvent, item: AmsItem) => {
    track.itemClick(item, event)
}

const onItemInViewport = (item: AmsItem) => {
    track.viewport(item)
}

const onPriceIndicatorClick = (item: AmsItem, isOpened: boolean) => {
    track.onPriceIndicatorClick(item, isOpened)
}
</script>
<style scoped lang="scss">
:deep(.ams-resultListDisturber > *) {
    @apply my-40;
}
</style>
